export const RUOLI_PERSONALE = [
  'Dirigente', 'Project Manager', 'Commerciale',
  'Amministrativo', 'Tecnico Senior', 'Tecnico', 'Operativo'
] as const

export type RuoloPersonale = typeof RUOLI_PERSONALE[number]

export type StatoPersonale = 'attivo' | 'temporaneamente_non_disponibile' | 'cessato'

export interface Personale {
  id: string
  nome: string
  cognome: string
  data_nascita: string | null
  indirizzo_residenza: string | null
  telefono: string | null
  data_assunzione: string | null
  tipo_contratto: string | null
  ruolo: string | null
  reparto: string | null
  data_fine_rapporto: string | null
  stato: StatoPersonale
  has_firma: boolean
  user_id: string | null
  user_email: string | null
  skill: string[] | null
  note: string | null
  created_at: string
}

export interface PersonaleForm {
  nome: string
  cognome: string
  data_nascita: string
  indirizzo_residenza: string
  telefono: string
  data_assunzione: string
  tipo_contratto: string
  ruolo: string
  reparto: string
  data_fine_rapporto: string
  stato: StatoPersonale
  skill: string[]
  note: string
}

export interface BulkDownloadAllegato {
  id: string
  titolo: string
  filename: string
  file_size: number
  content_type: string
  created_at: string
}

export interface BulkDownloadGroup {
  personale_id: string
  nome_completo: string
  allegati: BulkDownloadAllegato[]
}
